import red from 'material-ui/colors/red';

const settings = {
  /*typography: {
    fontFamily: 'Open sans, sans-serif'
  },*/
  palette: {
    primary: red,
    error: red,
  },

};

export default {
  theme: settings,
};



// WEBPACK FOOTER //
// ./src/common/Theme.js